var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOnlinetest(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 40,
    viewBox: "0 0 63 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.84073 2.70415L58.6874 2.60509C59.4536 2.60381 60.078 3.34352 60.078 4.25305L60.135 39.7556C60.8782 39.3825 61.6965 39.1085 62.59 38.94L62.5342 4.24791C62.533 1.90269 60.8042 -0.00385354 58.6862 5.84908e-06L3.83952 0.097777C1.72033 0.101636 -0.00363131 2.01332 5.74426e-06 4.35983L0.0557737 39.506C0.93594 39.578 1.76034 39.7401 2.51321 40L2.45501 4.35597C2.45501 3.44644 3.07453 2.70544 3.84073 2.70415Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7867 16.7679L17.453 29.0755L14.0245 25.6664L6.20728 37.0567L8.53135 39.0378L13.4208 32.1501L17.8155 35.9272L26.1407 23.5849L36.3863 32.4383L48.979 17.2979L56.4107 23.3443L55.3256 3.38867L37.2337 7.4436L43.5258 12.7207L35.22 24.4288L25.7867 16.7679Z",
    fill: "#F22C6B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnlinetest);
export default __webpack_public_path__ + "static/media/online test.7a0fb6a966bf6c1f190c338ca042400f.svg";
export { ForwardRef as ReactComponent };